import {
  LDSingleKindContext,
  useLDClient,
} from 'launchdarkly-react-client-sdk';
import FeatureFlagModule from '..';
import strings from '../strings';
import DiagnosticsModule from '@modules/DiagnosticsModule';

let isContextConfigured = false;
let isErrorReported = false;

export default function useFeatureFlagContext(): LDSingleKindContext {
  const ldClient = useLDClient();

  if (isContextConfigured || !FeatureFlagModule.ldContext.key) {
    // Either we've already configured it or we don't have an authenticated
    // user to configure it with yet. Either way, just return it as-is.
    return FeatureFlagModule.ldContext;
  }

  ldClient
    ?.identify(FeatureFlagModule.ldContext, undefined)
    .then(() => {
      isContextConfigured = true;
      FeatureFlagModule.log(
        'Switched LD context to',
        FeatureFlagModule.ldContext,
      );
    })
    .catch((err) => {
      if (!isErrorReported) {
        DiagnosticsModule.reportBackgroundError(
          err,
          strings.errors.featureFlagInitFailure,
          {
            priority: 'direct',
          },
        );
      }

      // In most cases, it's fine if this fails - only warn users once per pageload.
      isErrorReported = true;
      isContextConfigured = false;

      FeatureFlagModule.log('We got an error:', err);
    });

  // Mark context as configured to avoid multiple configuration attempts while
  // the first one runs. If configuration fails we unset this in the catch()
  // handler.
  isContextConfigured = true;

  return FeatureFlagModule.ldContext;
}
